import { ApiResult, request, safeRequest } from '@synergy/api';

import { CustomerConditions } from '../models/customer-conditions';
import { CustomerConditionsPatchRequest } from './models/customer-conditions-patch-request';

export class CustomerConditionsApi {
    constructor(protected baseUrl: string) {}

    public getConditions(customerId: number): Promise<ApiResult<CustomerConditions>> {
        return safeRequest(
            () => request.get(`${this.baseUrl}/customers/${customerId}/conditions`),
            response => response.data
        );
    }

    public updateConditions(
        customerId: number,
        patch: CustomerConditionsPatchRequest
    ): Promise<ApiResult<CustomerConditions>> {
        return safeRequest(
            () => request.patch(`${this.baseUrl}/customers/${customerId}/conditions`, patch),
            response => response.data
        );
    }
}
